export default "__VITE_ASSET__fc704c57__"